// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #3369b0;
  --secondary-color: #3a85e7;
  --background-color: #f9f9f9;
  --table-bg: #ffffff;
  --table-alt: #f2f2f2;
  --hover-bg: #e6f0ff;
  --text-color: #333;
  --filter-bg: #f5f5f5;
  --danger: #dc3545;
  --success: #28a745;
  --pass-bg: #f0f8f0;
  --fail-bg: #eecccc;
  --border-color: #ddd;
}

[data-theme="dark"] {
  --primary-color: #4b8bd4;
  --secondary-color: #3980d1;
  --background-color: #1e1e1e;
  --table-bg: #2c2c2c;
  --table-alt: #333;
  --hover-bg: #3a3a3a;
  --text-color: #eee;
  --filter-bg: #2c2c2c;
  --danger: #ff6666;
  --success: #44d27a;
  --pass-bg: #fff0f0;
  --fail-bg: #5f4a4a;
  --border-color: #555;
}

body {
  background-color: var(--background-color);
  color: var(--text-color);
  margin: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.App {
  padding: 0;
  min-height: 100vh;
}

.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  height: 60px;
  position: sticky;
  top: 0;
  z-index: 100;
}

.theme-toggle {
  background: none;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.2s ease;
  color: var(--text-color);
}

.theme-toggle:hover {
  background-color: #f5f5f5;
  border-color: #007bff;
}

[data-theme="dark"] .top-bar {
  background-color: #1a1a1a;
  border-bottom-color: #404040;
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

[data-theme="dark"] .theme-toggle {
  background-color: #2d2d2d;
  border-color: #404040;
  color: #ffffff;
}

[data-theme="dark"] .theme-toggle:hover {
  background-color: #404040;
  border-color: #007bff;
}

button {
  background-color: var(--secondary-color);
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s ease;
}

button:hover {
  background-color: #689e47;
}

table {
  width: 100%;
  border-collapse: collapse;
  background-color: var(--table-bg);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

th, td {
  padding: 12px;
  border: 1px solid var(--border-color);
  text-align: center;
}

th {
  background-color: var(--primary-color);
  color: white;
}

tr:nth-child(even) {
  background-color: var(--table-alt);
}

tr:hover {
  background-color: var(--hover-bg);
}

/* 반응형 */
@media (max-width: 768px) {
  .header-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  table, thead, tbody, th, td, tr {
    display: block;
  }

  th, td {
    text-align: right;
    position: relative;
    padding-left: 50%;
  }

  th::before, td::before {
    position: absolute;
    left: 15px;
    top: 12px;
    white-space: nowrap;
    font-weight: bold;
    text-align: left;
  }

  th:nth-of-type(1)::before { content: "ID"; }
  th:nth-of-type(2)::before { content: "Topic"; }
  th:nth-of-type(3)::before { content: "Machine"; }
  th:nth-of-type(4)::before { content: "Temp"; }
  th:nth-of-type(5)::before { content: "Timestamp"; }

  td:nth-of-type(1)::before { content: "ID"; }
  td:nth-of-type(2)::before { content: "Topic"; }
  td:nth-of-type(3)::before { content: "Machine"; }
  td:nth-of-type(4)::before { content: "Temp"; }
  td:nth-of-type(5)::before { content: "Timestamp"; }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;EACxB,SAAS;EACT,4DAA4D;AAC9D;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,qCAAqC;EACrC,YAAY;EACZ,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,QAAQ;AACR;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,4BAA4B,aAAa,EAAE;EAC3C,4BAA4B,gBAAgB,EAAE;EAC9C,4BAA4B,kBAAkB,EAAE;EAChD,4BAA4B,eAAe,EAAE;EAC7C,4BAA4B,oBAAoB,EAAE;;EAElD,4BAA4B,aAAa,EAAE;EAC3C,4BAA4B,gBAAgB,EAAE;EAC9C,4BAA4B,kBAAkB,EAAE;EAChD,4BAA4B,eAAe,EAAE;EAC7C,4BAA4B,oBAAoB,EAAE;AACpD","sourcesContent":[":root {\r\n  --primary-color: #3369b0;\r\n  --secondary-color: #3a85e7;\r\n  --background-color: #f9f9f9;\r\n  --table-bg: #ffffff;\r\n  --table-alt: #f2f2f2;\r\n  --hover-bg: #e6f0ff;\r\n  --text-color: #333;\r\n  --filter-bg: #f5f5f5;\r\n  --danger: #dc3545;\r\n  --success: #28a745;\r\n  --pass-bg: #f0f8f0;\r\n  --fail-bg: #eecccc;\r\n  --border-color: #ddd;\r\n}\r\n\r\n[data-theme=\"dark\"] {\r\n  --primary-color: #4b8bd4;\r\n  --secondary-color: #3980d1;\r\n  --background-color: #1e1e1e;\r\n  --table-bg: #2c2c2c;\r\n  --table-alt: #333;\r\n  --hover-bg: #3a3a3a;\r\n  --text-color: #eee;\r\n  --filter-bg: #2c2c2c;\r\n  --danger: #ff6666;\r\n  --success: #44d27a;\r\n  --pass-bg: #fff0f0;\r\n  --fail-bg: #5f4a4a;\r\n  --border-color: #555;\r\n}\r\n\r\nbody {\r\n  background-color: var(--background-color);\r\n  color: var(--text-color);\r\n  margin: 0;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n\r\n.App {\r\n  padding: 0;\r\n  min-height: 100vh;\r\n}\r\n\r\n.top-bar {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0 20px;\r\n  background-color: #ffffff;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n  height: 60px;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 100;\r\n}\r\n\r\n.theme-toggle {\r\n  background: none;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 8px;\r\n  padding: 8px 12px;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  transition: all 0.2s ease;\r\n  color: var(--text-color);\r\n}\r\n\r\n.theme-toggle:hover {\r\n  background-color: #f5f5f5;\r\n  border-color: #007bff;\r\n}\r\n\r\n[data-theme=\"dark\"] .top-bar {\r\n  background-color: #1a1a1a;\r\n  border-bottom-color: #404040;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.3);\r\n}\r\n\r\n[data-theme=\"dark\"] .theme-toggle {\r\n  background-color: #2d2d2d;\r\n  border-color: #404040;\r\n  color: #ffffff;\r\n}\r\n\r\n[data-theme=\"dark\"] .theme-toggle:hover {\r\n  background-color: #404040;\r\n  border-color: #007bff;\r\n}\r\n\r\nbutton {\r\n  background-color: var(--secondary-color);\r\n  color: white;\r\n  padding: 10px 20px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\nbutton:hover {\r\n  background-color: #689e47;\r\n}\r\n\r\ntable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  background-color: var(--table-bg);\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\nth, td {\r\n  padding: 12px;\r\n  border: 1px solid var(--border-color);\r\n  text-align: center;\r\n}\r\n\r\nth {\r\n  background-color: var(--primary-color);\r\n  color: white;\r\n}\r\n\r\ntr:nth-child(even) {\r\n  background-color: var(--table-alt);\r\n}\r\n\r\ntr:hover {\r\n  background-color: var(--hover-bg);\r\n}\r\n\r\n/* 반응형 */\r\n@media (max-width: 768px) {\r\n  .header-container {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 10px;\r\n  }\r\n\r\n  table, thead, tbody, th, td, tr {\r\n    display: block;\r\n  }\r\n\r\n  th, td {\r\n    text-align: right;\r\n    position: relative;\r\n    padding-left: 50%;\r\n  }\r\n\r\n  th::before, td::before {\r\n    position: absolute;\r\n    left: 15px;\r\n    top: 12px;\r\n    white-space: nowrap;\r\n    font-weight: bold;\r\n    text-align: left;\r\n  }\r\n\r\n  th:nth-of-type(1)::before { content: \"ID\"; }\r\n  th:nth-of-type(2)::before { content: \"Topic\"; }\r\n  th:nth-of-type(3)::before { content: \"Machine\"; }\r\n  th:nth-of-type(4)::before { content: \"Temp\"; }\r\n  th:nth-of-type(5)::before { content: \"Timestamp\"; }\r\n\r\n  td:nth-of-type(1)::before { content: \"ID\"; }\r\n  td:nth-of-type(2)::before { content: \"Topic\"; }\r\n  td:nth-of-type(3)::before { content: \"Machine\"; }\r\n  td:nth-of-type(4)::before { content: \"Temp\"; }\r\n  td:nth-of-type(5)::before { content: \"Timestamp\"; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
